import { useContext } from '@/compat';
import { DialogColors } from '@/components/dialogs/constants';

const useAlert = () => {
  const { $i18n, $lang, $root } = useContext();

  const okButtonText = $i18n.t($lang.app.OK);

  const error = async (title, message, options) => $root.$alert(
    title, message, { color: DialogColors.ERROR, okButtonText, ...options },
  );

  const warning = async (title, message, options) => $root.$alert(
    title, message, { color: DialogColors.WARNING, okButtonText, ...options },
  );

  const success = async (title, message, options) => $root.$alert(
    title, message, { color: DialogColors.SUCCESS, okButtonText, ...options },
  );

  const info = async (title, message, options) => $root.$alert(
    title, message, { color: DialogColors.INFO, okButtonText, ...options },
  );

  const primary = async (title, message, options) => $root.$alert(
    title, message, { color: DialogColors.PRIMARY, okButtonText, ...options },
  );

  return {
    error,
    warning,
    success,
    info,
    primary,
  };
};

export default useAlert;
